export const statuses = [
  { isActive: true, value: 'Active' },
  { isActive: false, value: 'Inactive' },
  { isActive: false, value: 'Verified' },
  { isActive: false, value: 'Unverified' },
]
export const sortOptions = ['Last name (A-Z)', 'Last name (Z-A)', 'Modified bookings', 'Active since']

export const states = [
  { isActive: false, value: 'Alabama', code: 'AL' },
  { isActive: false, value: 'Alaska', code: 'AK' },
  { isActive: false, value: 'Arizona', code: 'AZ' },
  { isActive: false, value: 'Arkansas', code: 'AR' },
  { isActive: false, value: 'California', code: 'CA' },
  { isActive: false, value: 'Colorado', code: 'CO' },
  { isActive: false, value: 'Connecticut', code: 'CT' },
  { isActive: false, value: 'Delaware', code: 'DE' },
  { isActive: false, value: 'District of Columbia', code: 'DC' },
  { isActive: false, value: 'Florida', code: 'FL' },
  { isActive: false, value: 'Georgia', code: 'GA' },
  { isActive: false, value: 'Hawaii', code: 'HI' },
  { isActive: false, value: 'Idaho', code: 'ID' },
  { isActive: false, value: 'Illinois', code: 'IL' },
  { isActive: false, value: 'Indiana', code: 'IN' },
  { isActive: false, value: 'Iowa ', code: 'IA' },
  { isActive: false, value: 'Kansas', code: 'KS' },
  { isActive: false, value: 'Kentucky', code: 'KY' },
  { isActive: false, value: 'Louisiana', code: 'LA' },
  { isActive: false, value: 'Maine', code: 'ME' },
  { isActive: false, value: 'Maryland', code: 'MD' },
  { isActive: false, value: 'Massachusetts', code: 'MA' },
  { isActive: false, value: 'Michigan', code: 'MI' },
  { isActive: false, value: 'Minnesota', code: 'MN' },
  { isActive: false, value: 'Mississippi', code: 'MS' },
  { isActive: false, value: 'Missouri', code: 'MO' },
  { isActive: false, value: 'Montana', code: 'MT' },
  { isActive: false, value: 'Nebraska', code: 'NE' },
  { isActive: false, value: 'Nevada', code: 'NV' },
  { isActive: false, value: 'New Hampshire', code: 'NH' },
  { isActive: false, value: 'New Jersey', code: 'NJ' },
  { isActive: false, value: 'New Mexico', code: 'NM' },
  { isActive: false, value: 'New York ', code: 'NY' },
  { isActive: false, value: 'North Carolina', code: 'NC' },
  { isActive: false, value: 'North Dakota', code: 'ND' },
  { isActive: false, value: 'Ohio', code: 'OH' },
  { isActive: false, value: 'Oklahoma ', code: 'OK' },
  { isActive: false, value: 'Oregon', code: 'OR' },
  { isActive: false, value: 'Pennsylvania', code: 'PA' },
  { isActive: false, value: 'Rhode Island', code: 'RI' },
  { isActive: false, value: 'South Carolina', code: 'SC' },
  { isActive: false, value: 'South Dakota', code: 'SD' },
  { isActive: false, value: 'Tennessee', code: 'TN' },
  { isActive: false, value: 'Texas', code: 'TX' },
  { isActive: false, value: 'Utah', code: 'UT' },
  { isActive: false, value: 'Vermont', code: 'VT' },
  { isActive: false, value: 'Virginia', code: 'VA' },
  { isActive: false, value: 'Washington', code: 'WA' },
  { isActive: false, value: 'West Virginia', code: 'WV' },
  { isActive: false, value: 'Wisconsin', code: 'WI' },
  { isActive: false, value: 'Wyoming', code: 'WY' },
]

export function getSortValue(name: string) {
  switch (name) {
    case 'Last name (A-Z)':
      return 'lastnameascending'
    case 'Last name (Z-A)':
      return 'lastnamedescending'
    case 'Modified bookings':
      return 'modifiedvisibility'
    case 'Active since':
      return 'visitsdatetimeascending'
    default:
      return ''
  }
}

export function getSortName(name: string) {
  switch (name) {
    case 'lastnameascending':
      return 'Last name (A-Z)'
    case 'lastnamedescending':
      return 'Last name (Z-A)'
    case 'modifiedvisibility':
      return 'Modified bookings'
    case 'visitdatetimeascending':
      return 'Active since'
    default:
      return ''
  }
}

// @ts-expect-error TS7006 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
export const generateMultiSelectOptionsList = (serviceTypes, selectedVisitTypesListFromSearchParams) => {
  if (!serviceTypes.length) {
    return []
  }
  return (
    serviceTypes

      // @ts-expect-error TS7006 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
      .map((serviceType) =>
        // @ts-expect-error TS7006 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
        serviceType.VisitTypes.map((visitType) => {
          if (visitType.VisibilityType === 'all') {
            return {
              filterValue: `${visitType.Name?.trim()}`,
              value: `${serviceType.Name} (${visitType.Name?.trim()})`,
              visitTypeId: visitType.VisitTypeId,
              isActive: selectedVisitTypesListFromSearchParams?.includes(visitType.VisitTypeId),
            }
          }
          return undefined
          // @ts-expect-error TS7006 TEMP ERROR SUPPRESSION: CRA -> REACT ROUTER
        }).filter((item) => item !== undefined),
      )
      .flat()
  )
}
